import { render, staticRenderFns } from "./LogsManagerLandingPage.vue?vue&type=template&id=48e73c3a&"
import script from "./LogsManagerLandingPage.vue?vue&type=script&lang=js&"
export * from "./LogsManagerLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports